<template>
  <div>
    <div
      class="row page-content-wrapper"
      style="width: 100%;flex: 0 0 auto;flex-wrap: nowrap;"
    >
      <div class="col col-auto">
        <div class="drag-handle sticky-menu-2" :class="sticking2">
          <h1 class="mb-0 text-center">
            <i class="fas fa-grip-vertical"></i>
          </h1>
        </div>
        <div
          class="text-center btn-panel mt-4 sticky-menu"
          :class="{ sticking }"
          style="margin-right: 8px"
        >
          <div @click="onNewContent ? onNewContent() : () => {}">
            <vx-tooltip text="Add Content">
              <i class="fas fa-plus-circle"></i>
            </vx-tooltip>
          </div>
          <div @click="onCopyContent ? onCopyContent() : () => {}">
            <vx-tooltip text="Duplicate">
              <i class="far fa-copy"></i>
            </vx-tooltip>
          </div>
          <div @click="onDelete ? onDelete() : () => {}">
            <vx-tooltip text="Delete">
              <i class="fas fa-trash-alt"></i>
            </vx-tooltip>
          </div>
          <div @click="onMoveUp ? onMoveUp() : () => {}">
            <vx-tooltip text="Move Up">
              <i class="fas fa-arrow-up"></i>
            </vx-tooltip>
          </div>
          <div @click="onMoveDown ? onMoveDown() : () => {}">
            <vx-tooltip text="Move Down">
              <i class="fas fa-arrow-down"></i>
            </vx-tooltip>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="content-container" style=" width: calc(100vw - 460px);">
          <div class="d-flex">
            <vs-input
              id="title"
              v-model="title"
              @change="updateContent"
              class="mb-0"
              :placeholder="'Title'"
              style="min-width: 300px"
              size="large"
            ></vs-input>
            <vs-button
              class="add-option-button ml-auto  "
              @click="openContentDialog()"
            >
              Edit Item
            </vs-button>
          </div>
          <!-- Add publish date inputs -->
          <div class="d-inline-flex pt-4 align-items-center">
            <div id="contentType" icon="list" class="mb-3">
              <b-form-select
                v-model="contentType"
                id="contentType"
                class="bootstrap-dropdown"
                style="height: 55px;min-width:500px;max-width:100%"
                size="lg"
                @change="value => onContentTypeChange(value)"
              >
                <optgroup
                  v-for="group in contentTypes"
                  :label="group.label"
                  :key="group.text"
                >
                  <option
                    v-for="option in group.options"
                    :key="option.slug"
                    :label="option.label"
                    :value="option.slug"
                  ></option>
                </optgroup>
              </b-form-select>
            </div>
            <div class="">
              <!-- <vs-button
                class="add-option-button ml-5 px-5 "
                @click="editContentDialog = true"
              >
                Edit Item List
              </vs-button> -->
            </div>
          </div>
          <div style="overflow: auto;">
            <div
              v-if="
                isContentAvailable &&
                  value.content_json.content.entity_type == 'event'
              "
              class="d-flex"
              style="flex:0 0 auto"
            >
              <div
                class="mr-2"
                style="width:240px;flex:none;"
                v-for="(item, index) in value.content_json.content.entity_ids"
                :key="index"
              >
                <vs-card style="box-shadow: none;">
                  <div class="">
                    <img
                      v-if="
                        item_list_event_ids_options.find(ep => ep.value == item)
                      "
                      :src="
                        item_list_event_ids_options.find(ep => ep.value == item)
                          .poster
                      "
                      style="height:135px;width:240px;object-fit: cover;"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="
                      item_list_event_ids_options.find(ep => ep.value == item)
                    "
                    class="mt-2 overflow-hidden"
                  >
                    {{
                      item_list_event_ids_options.find(ep => ep.value == item)
                        .label
                    }}
                  </div>
                </vs-card>
              </div>
            </div>
            <div
              v-if="
                isContentAvailable &&
                  value.content_json.content.entity_type == 'product'
              "
              class="d-flex"
              style="flex:0 0 auto"
            >
              <div
                class="mr-2"
                style="width:240px;flex:none;"
                v-for="(item, index) in value.content_json.content.entity_ids"
                :key="index"
              >
                <vs-card style="box-shadow: none;">
                  <div class="">
                    <img
                      v-if="
                        item_list_product_ids_options.find(
                          ep => ep.value == item
                        )
                      "
                      :src="
                        item_list_product_ids_options.find(
                          ep => ep.value == item
                        ).poster
                      "
                      style="height:240px;width:240px;object-fit: cover;"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="
                      item_list_product_ids_options.find(ep => ep.value == item)
                    "
                    class="mt-2 overflow-hidden"
                  >
                    {{
                      item_list_product_ids_options.find(ep => ep.value == item)
                        .label
                    }}
                  </div>
                </vs-card>
              </div>
            </div>
            <div
              v-if="
                isContentAvailable &&
                  value.content_json.content.entity_type == 'video'
              "
              class="d-flex"
              style="flex:0 0 auto"
            >
              <div
                class="mr-2"
                style="width:240px;flex:none;"
                v-for="(item, index) in value.content_json.content.entity_ids"
                :key="index"
              >
                <vs-card style="box-shadow: none;">
                  <div class="">
                    <img
                      v-if="
                        item_list_video_ids_options.find(ep => ep.value == item)
                      "
                      :src="
                        item_list_video_ids_options.find(ep => ep.value == item)
                          .poster
                      "
                      style="height:135px;width:240px;object-fit: cover;"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="
                      item_list_video_ids_options.find(ep => ep.value == item)
                    "
                    class="mt-2 overflow-hidden"
                  >
                    {{
                      item_list_video_ids_options.find(ep => ep.value == item)
                        .label
                    }}
                  </div>
                </vs-card>
              </div>
            </div>
            <div
              v-if="
                isContentAvailable &&
                  contentType == 'banner' &&
                  value.content_json.config.style == 'grid'
              "
              class="d-flex"
              style="flex:0 0 auto"
            >
              <div
                class=""
                :style="
                  `width:${100 /
                    value.content_json.config
                      .columns}%;flex:none;padding-right:${
                    value.content_json.config.padding
                  }px;`
                "
                v-for="(item, index) in value.content_json.content.images"
                :key="index"
              >
                <!-- Link Wrapper -->
                <div v-if="item.link_type === 'entity'" class="banner-link">
                  <div class="image-container">
                    <img
                      :src="item.image"
                      style="height:135px;width:100%;object-fit: cover;"
                      alt=""
                    />
                    <!-- Entity Overlay -->
                    <div
                      v-if="item.link_entity_type === 'video'"
                      class="video-overlay"
                    >
                      <!-- <i class="fa fa-play-circle"></i> -->
                    </div>
                    <div
                      v-else-if="item.link_entity_type === 'product'"
                      class="product-overlay"
                    >
                      <!-- <i class="fa fa-shopping-cart"></i> -->
                    </div>
                  </div>
                </div>
                <a
                  v-else-if="item.link_type === 'url'"
                  :href="item.link_url"
                  target="_blank"
                  class="banner-link"
                >
                  <div class="image-container">
                    <img
                      :src="item.image"
                      style="height:135px;width:100%;object-fit: cover;"
                      alt=""
                    />
                  </div>
                </a>
                <div v-else class="image-container">
                  <img
                    :src="item.image"
                    style="height:135px;width:100%;object-fit: cover;"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- Carousel Style -->
            <div
              v-if="
                isContentAvailable &&
                  contentType == 'banner' &&
                  value.content_json.config.style == 'carousel'
              "
              class="d-flex"
              style="flex:0 0 auto"
            >
              <div
                class=""
                :style="
                  `width:${100 /
                    value.content_json.config
                      .columns}%;flex:none;padding-right:${
                    value.content_json.config.padding
                  }px;`
                "
                v-for="(item, index) in value.content_json.content.images"
                :key="index"
              >
                <!-- Link Wrapper -->
                <div
                  v-if="item.link_type === 'entity'"
                  :href="getEntityLink(item)"
                  class="banner-link"
                >
                  <div class="image-container">
                    <img
                      :src="item.image"
                      style="height:135px;width:100%;object-fit: cover;"
                      alt=""
                    />
                    <!-- Entity Overlay -->
                    <div
                      v-if="item.link_entity_type === 'video'"
                      class="video-overlay"
                    >
                      <i class="fa fa-play-circle"></i>
                    </div>
                    <div
                      v-else-if="item.link_entity_type === 'product'"
                      class="product-overlay"
                    >
                      <i class="fa fa-shopping-cart"></i>
                    </div>
                  </div>
                </div>
                <a
                  v-else-if="item.link_type === 'url'"
                  :href="item.link_url"
                  target="_blank"
                  class="banner-link"
                >
                  <div class="image-container">
                    <img
                      :src="item.image"
                      style="height:135px;width:100%;object-fit: cover;"
                      alt=""
                    />
                  </div>
                </a>
                <div v-else class="image-container">
                  <img
                    :src="item.image"
                    style="height:135px;width:100%;object-fit: cover;"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      buttons-hidden
      fullscreen
      title="Edit Content"
      :not-close="true"
      prevent-close
      :active.sync="editContentDialog"
    >
      <div style="min-height: 300px" class="m-5">
        <div id="contentType" icon="list">
          <div class="vx-row my-4">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Publish Date &amp; Time</span>
              <div style="font-size: 0.75rem; color: rgb(170, 170, 170);">
                Leave Start blank to publish immediately and End blank to keep
                the video available indefinitely
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="vx-row align-items-center">
                <div>
                  <el-date-picker
                    v-model="publishStartDate"
                    type="datetime"
                    style="width: 100%"
                    placeholder="Start"
                    value-format="yyyy-MM-dd HH:mm"
                    format="dd-MM-yyyy HH:mm"
                  >
                  </el-date-picker>
                </div>
                <div class="px-4">-</div>
                <div>
                  <el-date-picker
                    v-model="publishEndDate"
                    type="datetime"
                    style="width: 100%"
                    placeholder="End"
                    value-format="yyyy-MM-dd HH:mm"
                    format="dd-MM-yyyy HH:mm"
                  >
                  </el-date-picker>
                </div>
              </div>
              <!-- <span class="text-danger text-sm" v-show="errors.has('daterange')">
                  {{ splitError(errors.first("daterange"), "daterange") }}
                </span> -->
            </div>
          </div>
          <div>Content Type</div>
          <b-form-select
            v-model="contentDataFrom"
            id="contentDataFrom"
            class="bootstrap-dropdown mb-5"
            style="height: 55px;min-width:500px;max-width:100%"
            size="lg"
          >
            <optgroup label="Content Type">
              <option
                v-if="contentType == 'banner'"
                label="Banner"
                value="banner"
              ></option>
              <option
                v-if="contentType == 'item_list'"
                label="Product"
                value="product"
              ></option>
              <option
                v-if="contentType == 'item_list'"
                label="Video"
                value="video"
              ></option>
            </optgroup>
          </b-form-select>

          <div v-if="contentDataFrom == 'event'">
            <v-select
              class="hide-select-action mb-5"
              v-model="item_list_event_ids_search"
              :options="item_listEventSearchOptions"
              @input="onAddEventItemList"
              placeholder="Search Event"
            ></v-select>
            <div class="px-1 mt-4">
              <draggable
                v-model="item_list_event_ids_input"
                tag="div"
                class="row"
                :options="{
                  animation: 300
                }"
                ghost-class="ghost"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  class="col col-6 col-sm-4 col-md-2 col-lg-3 col-xl-2 col-xxl-2 cursor-move"
                  v-for="(item, index) in item_list_event_ids_input"
                  :key="index"
                >
                  <transition name="list" tag="div">
                    <vs-card class="position-relative">
                      <div
                        class="close-btn"
                        @click="removeItemListEvent(item.value)"
                      >
                        <i class="fas fa-times-circle"></i>
                      </div>
                      <div class="">
                        <img
                          :src="item.poster"
                          style="height:185px;width:100%;object-fit: cover;"
                          alt=""
                        />
                      </div>
                      <div
                        style="    overflow: hidden;
                          text-overflow: ellipsis;
                          -webkit-box-orient: vertical;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                          height: 45px;
                          "
                        class="mt-2 overflow-hidden"
                      >
                        {{ item.label }}
                      </div>
                    </vs-card>
                  </transition>
                </div>
              </draggable>
            </div>
          </div>

          <div v-if="contentDataFrom == 'product'">
            <v-select
              key="search-product"
              class="hide-select-action mb-5"
              v-model="item_list_product_ids_search"
              :options="item_listProductSearchOptions"
              @input="onAddProductItemList"
              placeholder="Search Product"
            ></v-select>
            <div class="px-1 mt-4">
              <draggable
                v-model="item_list_product_ids_input"
                tag="div"
                class="row"
                :options="{
                  animation: 300
                }"
                ghost-class="ghost"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  class="col col-6 col-sm-4 col-md-2 col-lg-3 col-xl-2 col-xxl-2 cursor-move"
                  v-for="(item, index) in item_list_product_ids_input"
                  :key="index"
                >
                  <transition name="list" tag="div">
                    <vs-card class="position-relative">
                      <div
                        class="close-btn"
                        @click="removeItemListProduct(item.value)"
                      >
                        <i class="fas fa-times-circle"></i>
                      </div>
                      <div class="">
                        <img
                          :src="item.poster"
                          class=""
                          style="height:185px;width:100%;object-fit: cover;"
                          alt=""
                        />
                      </div>
                      <div
                        style="    overflow: hidden;
                          text-overflow: ellipsis;
                          -webkit-box-orient: vertical;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                              height: 45px;"
                        class="mt-2 overflow-hidden"
                      >
                        {{ item.label }}
                      </div>
                    </vs-card>
                  </transition>
                </div>
              </draggable>
            </div>
          </div>
          <div v-if="contentDataFrom == 'video'">
            <v-select
              key="search-video"
              class="hide-select-action mb-5"
              v-model="item_list_video_ids_search"
              :options="item_listVideoSearchOptions"
              @input="onAddVideoItemList"
              placeholder="Search Video"
            ></v-select>
            <div class="px-1 mt-4">
              <draggable
                v-model="item_list_video_ids_input"
                tag="div"
                class="row"
                :options="{
                  animation: 300
                }"
                ghost-class="ghost"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  class="col col-6 col-sm-4 col-md-2 col-lg-3 col-xl-2 col-xxl-2 cursor-move"
                  v-for="(item, index) in item_list_video_ids_input"
                  :key="index"
                >
                  <transition name="list" tag="div">
                    <vs-card class="position-relative">
                      <div
                        class="close-btn"
                        @click="removeItemListVideo(item.value)"
                      >
                        <i class="fas fa-times-circle"></i>
                      </div>
                      <div class="">
                        <img
                          :src="item.poster"
                          class=""
                          style="height:185px;width:100%;object-fit: cover;"
                          alt=""
                        />
                      </div>
                      <div
                        style="    overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-box-orient: vertical;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        height: 45px;"
                        class="mt-2 overflow-hidden"
                      >
                        {{ item.label }}
                      </div>
                    </vs-card>
                  </transition>
                </div>
              </draggable>
            </div>
          </div>
          <div v-if="contentDataFrom === 'banner'">
            <h3>Banner Content</h3>

            <!-- Upload Area -->
            <div
              class="upload-area mb-4"
              :class="{ dragging: isDragging }"
              @dragenter.prevent="isDragging = true"
              @dragleave.prevent="onDragLeave"
              @dragover.prevent
              @drop.prevent="onDrop"
              @click="$refs.bannerUpload.click()"
            >
              <input
                ref="bannerUpload"
                type="file"
                multiple
                @change="handleBannerImageUpload"
                accept="image/*"
                class="hidden"
              />

              <div class="upload-content">
                <i class="fas fa-cloud-upload-alt upload-icon"></i>
                <p class="upload-text">
                  Drag and drop images here or
                  <span class="upload-button">
                    browse
                  </span>
                </p>
                <p class="upload-hint">Support: JPG, PNG, JPEG</p>
              </div>
            </div>

            <!-- Display Style Configuration -->
            <div class="mt-4 mb-4">
              <h4 class="mb-3">Display Style</h4>
              <div class="mb-4">
                <vs-radio
                  v-model="bannerConfig.style"
                  vs-value="grid"
                  class="mr-4"
                  >Grid</vs-radio
                >
                <vs-radio v-model="bannerConfig.style" vs-value="carousel"
                  >Carousel</vs-radio
                >
              </div>

              <div class="row">
                <div class="col-6">
                  <label class="mb-2">Columns</label>
                  <vs-input-number
                    v-model="bannerConfig.columns"
                    :min="1"
                    :max="4"
                  ></vs-input-number>
                </div>
                <!-- <div class="col-6">
                  <label class="mb-2">Padding (px)</label>
                  <vs-input-number
                    v-model="bannerConfig.padding"
                    :min="0"
                    :max="40"
                  ></vs-input-number>
                </div> -->
              </div>
            </div>

            <!-- Banner Items Management -->
            <div v-if="bannerItems.length" class="mb-4">
              <h4 class="mb-3">Banner Items</h4>
              <div class="banner-items-container">
                <draggable
                  v-model="bannerItems"
                  tag="div"
                  class="row"
                  :options="{
                    animation: 300
                  }"
                  ghost-class="ghost"
                  @start="drag = true"
                  @end="drag = false"
                >
                  <div
                    class="col col-6 col-sm-4 col-md-2 col-lg-3 col-xl-2 col-xxl-2 cursor-move"
                    v-for="(item, index) in bannerItems"
                    :key="index"
                  >
                    <transition name="list" tag="div">
                      <vs-card class="position-relative banner-item-card">
                        <div class="banner-remove-btn text-grey" @click="removeBannerItem(index)">
                          <i class="fas fa-times-circle"></i>
                        </div>
                        <!-- Banner Image -->
                        <div class="banner-item-image">
                          <img :src="item.image" alt="" />
                        </div>

                        <!-- Link Type Selection -->
                        <div class="mt-2">
                          <b-form-select
                            v-model="item.link_type"
                            class="mb-2 link-type-select"
                            @change="val => handleLinkTypeChange(index, val)"
                            size="sm"
                          >
                            <option value="">No Link</option>
                            <option value="entity">Link to Content</option>
                            <option value="url">Custom URL</option>
                          </b-form-select>
                        </div>

                        <!-- Entity Type Selection (for entity links) -->
                        <div v-if="item.link_type === 'entity'" class="mt-2">
                          <b-form-select
                            v-model="item.link_entity_type"
                            class="mb-2"
                            @change="val => handleEntityTypeChange(index, val)"
                            size="sm"
                          >
                            <option value="video">Video</option>
                            <option value="product">Product</option>
                          </b-form-select>
                        </div>

                        <!-- Video Selection -->
                        <div
                          v-if="
                            item.link_type === 'entity' &&
                              item.link_entity_type === 'video'
                          "
                          class="video-link-section"
                        >
                          <v-select
                            class="hide-select-action mb-2"
                            :value="getVideoOption(item.link_entity_slug)"
                            :options="videoSelectOptions"
                            @input="
                              value => linkEntityToBanner(index, value, 'video')
                            "
                            placeholder="Select a video"
                          ></v-select>

                          <!-- Video Preview -->
                          <div
                            v-if="item.link_entity_slug"
                            class="video-preview"
                          >
                            <div class="video-preview-header">
                              <span class="video-preview-label">Video:</span>
                              <i
                                class="fas fa-times-circle text-danger cursor-pointer"
                                @click="unlinkEntity(index)"
                                title="Unlink video"
                              ></i>
                            </div>
                            <div class="video-preview-content">
                              <img
                                :src="
                                  getVideoPreviewImage(item.link_entity_slug)
                                "
                                alt="Video Preview"
                                class="video-thumbnail"
                              />
                              <div class="video-info">
                                <div class="video-title">
                                  {{ getVideoTitle(item.link_entity_slug) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Product Selection -->
                        <div
                          v-if="
                            item.link_type === 'entity' &&
                              item.link_entity_type === 'product'
                          "
                          class="product-link-section"
                        >
                          <v-select
                            class="hide-select-action mb-2"
                            :value="getProductOption(item.link_entity_slug)"
                            :options="productSelectOptions"
                            @input="
                              value =>
                                linkEntityToBanner(index, value, 'product')
                            "
                            placeholder="Select a product"
                          ></v-select>

                          <!-- Product Preview -->
                          <div
                            v-if="item.link_entity_slug"
                            class="video-preview"
                          >
                            <!-- Similar to video preview but for products -->
                            <img
                              :src="
                                getProductPreviewImage(item.link_entity_slug)
                              "
                              alt="Product Preview"
                              class="video-thumbnail"
                            />
                            <div class="video-info">
                              <div class="video-title">
                                {{ getProductTitle(item.link_entity_slug) }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- URL Input -->
                        <div v-if="item.link_type === 'url'" class="mt-2">
                          <vs-input
                            class="w-full"
                            v-model="item.link_url"
                            placeholder="Enter URL"
                          >
                            <template #icon>
                              <i class="fas fa-link"></i>
                            </template>
                          </vs-input>
                          <small class="url-hint" v-if="item.link_url">
                            <i class="fas fa-external-link-alt mr-1"></i>
                            {{ formatUrl(item.link_url) }}
                          </small>
                        </div>
                      </vs-card>
                    </transition>
                  </div>
                </draggable>
              </div>
            </div>

            <!-- Live Preview Section -->
            <div v-if="false" class="preview-section">
              <div class="preview-header">
                <h4 class="mb-3">Live Preview</h4>
              </div>

              <div class="preview-container" :class="previewSize">
                <div
                  :class="[
                    'banner-preview',
                    bannerConfig.style === 'column'
                      ? 'grid-view'
                      : 'carousel-view'
                  ]"
                  :style="{
                    gap: `${bannerConfig.padding}px`,
                    gridTemplateColumns:
                      bannerConfig.style === 'column'
                        ? `repeat(${bannerConfig.columns}, 1fr)`
                        : null
                  }"
                >
                  <div
                    v-for="(item, index) in previewItems"
                    :key="index"
                    class="banner-preview-item"
                  >
                    <img :src="item.image" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-divider />
      <div class="fixed-bottom-bar">
        <div class="bottom-bar-content">
          <vs-button class="apply-button" @click="updateContent()"
            >Apply</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import draggable from "vuedraggable";
import ConditionSetting from "@/components/soldoutt/forms/ConditionSetting.vue";
import Service from "@/services";
import { mapState } from "vuex";
// const short = require("short-uuid");
// const translator = short();

export default {
  components: { vSelect, draggable, ConditionSetting },
  props: {
    page_id: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    onNewContent: {
      type: Function
    },
    onCopyContent: {
      type: Function
    },
    onDelete: {
      type: Function
    },
    onMoveUp: {
      type: Function
    },
    onMoveDown: {
      type: Function
    },
    products: {
      type: Array,
      required: true
    },
    events: {
      type: Array,
      required: true
    },
    videos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      previewSize: "desktop",
      drag: false,
      title: this.value.title || "",
      contentType: this.value.type || "item_list",
      contentDataFrom:
        this.value && this.value.content_json && this.value.content_json.content
          ? this.value.content_json.content.entity_type
          : "video",
      show: this.value.listing_status == 1,
      publishStartDate: this.value.datetime_start || null,
      publishEndDate: this.value.datetime_end || null,
      contentTypes: [
        {
          label: "Content Tyoe",
          options: [
            { label: "Banner", slug: "banner", value: "banner" },
            { label: "Item List", slug: "item_list", value: "item_list" }
          ]
        }
      ],
      sticking: false,
      sticking2: false,
      editContentDialog: false,
      item_list_product_ids_options: [],
      item_list_event_ids_options: [],
      item_list_video_ids_options: [],
      item_list_product_ids_search: "",
      item_list_product_ids_input: [],
      item_list_event_ids_search: "",
      item_list_event_ids_input: [],
      item_list_video_ids_search: "",
      item_list_video_ids_input: [],
      is_event_loaded: false,
      slide_setting: {
        dots: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        variableWidth: true,
        arrow: true
      },
      bannerImages: [],
      bannerConfig: {
        style: "grid",
        columns: 2,
        padding: 0
      },
      bannerItems: [],
      isDragging: false,
      dragCounter: 0,
      savedBannerData: null,
      savedBannerConfig: null
    };
  },
  watch: {
    "value.datetime_start"(newVal) {
      this.publishStartDate = newVal;
    },
    "value.datetime_end"(newVal) {
      this.publishEndDate = newVal;
    },
    products(val) {
      this.item_list_product_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_title,
          value: item.product_id,
          item: item,
          poster: item.poster
        };
        return mapped_item;
      });
      if (
        this.value &&
        this.value.content_json &&
        this.value.content_json.content &&
        this.value.content_json.content.entity_type == "product"
      ) {
        this.item_list_product_ids_input =
          this.value &&
          this.value.content_json &&
          this.value.content_json.content
            ? this.value.content_json.content.entity_ids
                .map(item =>
                  this.item_list_product_ids_options.find(
                    ep => ep.value == item
                  )
                )
                .filter(item => !!item)
            : [];
      }
    },
    events(val) {
      this.item_list_event_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_name,
          value: item.event_id,
          e: item.slug,
          poster: item.poster
        };
        return mapped_item;
      });
      this.is_event_loaded = true;
      if (
        this.value &&
        this.value.content_json &&
        this.value.content_json.content &&
        this.value.content_json.content.entity_type == "event"
      ) {
        setTimeout(() => {
          this.item_list_event_ids_input =
            this.value &&
            this.value.content_json &&
            this.value.content_json.content
              ? this.value.content_json.content.entity_ids
                  .map(item =>
                    this.item_list_event_ids_options.find(ep => {
                      return ep.value == item;
                    })
                  )
                  .filter(item => !!item)
              : [];
        }, 300);
      }
    },
    videos(val) {
      this.item_list_video_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_name,
          value: item.video_id,
          e: item.slug,
          item: item,
          poster: item.poster
        };
        return mapped_item;
      });

      if (
        this.value &&
        this.value.content_json &&
        this.value.content_json.content &&
        this.value.content_json.content.entity_type == "video"
      ) {
        setTimeout(() => {
          this.item_list_video_ids_input =
            this.value &&
            this.value.content_json &&
            this.value.content_json.content
              ? this.value.content_json.content.entity_ids
                  .map(item =>
                    this.item_list_video_ids_options.find(ep => {
                      return ep.value == item;
                    })
                  )
                  .filter(item => !!item)
              : [];
        }, 300);
      }
    }
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    isValidDateRange() {
      if (!this.publishStartDate || !this.publishEndDate) return true;
      return new Date(this.publishStartDate) <= new Date(this.publishEndDate);
    },
    isContentAvailable() {
      return (
        this.value && this.value.content_json && this.value.content_json.content
      );
    },
    item_listEventSearchOptions() {
      return this.item_list_event_ids_options.filter(
        item =>
          !this.item_list_event_ids_input.find(ip => ip.value == item.value)
      );
    },
    item_listProductSearchOptions() {
      return this.item_list_product_ids_options.filter(
        item =>
          !this.item_list_product_ids_input.find(ip => ip.value == item.value)
      );
    },
    item_listVideoSearchOptions() {
      return this.item_list_video_ids_options.filter(
        item =>
          !this.item_list_video_ids_input.find(ip => ip.value == item.value)
      );
    },
    speakers_select_options() {
      return this.item_list_speaker_ids_options.filter(
        item =>
          !this.item_list_speaker_ids_input.find(ip => ip.value == item.value)
      );
    },
    contentValue: {
      get() {
        return this.value;
      },
      set() {}
    },
    flattenedContentTypes() {
      // Flatten the nested structure for v-select
      return this.contentTypes.flatMap(group => group.options);
    },
    previewItems() {
      if (this.bannerConfig.style === "carousel") {
        return this.bannerItems.slice(0, this.bannerConfig.columns);
      }
      return this.bannerItems;
    },
    videoSelectOptions() {
      return this.item_list_video_ids_options.map(video => {
        return {
          label: video.label,
          value: video.item.slug,
          id: video.item.video_id,
          poster: video.poster
        };
      });
    },
    productSelectOptions() {
      return this.products.map(product => {
        return {
          label: product.pro_title,
          value: product.slug,
          id: product.product_id,
          poster: product.poster
        };
      });
    }
  },
  mounted() {
    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticking = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer.observe(this.$refs.target);
      const observer2 = new IntersectionObserver(
        ([entry]) => {
          this.sticking2 = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer2.observe(this.$refs.target);
    } catch (_) {
      console.log();
    }

    this.item_list_product_ids_options = this.products.map(item => {
      const mapped_item = {
        label: item.pro_title,
        value: item.product_id,
        item: item,
        poster: item.poster
      };
      return mapped_item;
    });
    if (
      this.value &&
      this.value.content_json &&
      this.value.content_json.content &&
      this.value.content_json.content.entity_type == "product"
    ) {
      this.item_list_product_ids_input =
        this.value && this.value.content_json && this.value.content_json.content
          ? this.value.content_json.content.entity_ids
              .map(item =>
                this.item_list_product_ids_options.find(ep => ep.value == item)
              )
              .filter(item => !!item)
          : [];
    }

    this.item_list_event_ids_options = this.events.map(item => {
      const mapped_item = {
        label: item.pro_name,
        value: item.event_id,
        e: item.slug,
        poster: item.poster
      };
      return mapped_item;
    });

    this.item_list_video_ids_options = this.videos.map(item => {
      const mapped_item = {
        label: item.pro_name,
        value: item.video_id,
        e: item.slug,
        item: item,
        poster: item.poster
      };
      return mapped_item;
    });

    if (
      this.value &&
      this.value.content_json &&
      this.value.content_json.content &&
      this.value.content_json.content.entity_type == "video"
    ) {
      setTimeout(() => {
        this.item_list_video_ids_input =
          this.value &&
          this.value.content_json &&
          this.value.content_json.content
            ? this.value.content_json.content.entity_ids
                .map(item =>
                  this.item_list_video_ids_options.find(ep => {
                    return ep.value == item;
                  })
                )
                .filter(item => !!item)
            : [];
      }, 300);
    }

    this.is_event_loaded = true;
    if (
      this.value &&
      this.value.content_json &&
      this.value.content_json.content &&
      this.value.content_json.content.entity_type == "event"
    ) {
      setTimeout(() => {
        this.item_list_event_ids_input =
          this.value &&
          this.value.content_json &&
          this.value.content_json.content
            ? this.value.content_json.content.entity_ids
                .map(item =>
                  this.item_list_event_ids_options.find(ep => {
                    return ep.value == item;
                  })
                )
                .filter(item => !!item)
            : [];
      }, 300);
    }
  },
  methods: {
    onContentTypeChange(value) {
      if (value === "item_list") {
        if (!this.bannerItems || !this.bannerItems.length) {
          this.bannerItems = this.value.content_json.content.images.map(
            item => {
              if (typeof item === "string") {
                return {
                  image: item,
                  link_type: "",
                  link_entity_slug: "",
                  link_entity_id: "",
                  link_entity_type: "",
                  link_url: ""
                };
              }
              return {
                image: item.image,
                link_type: item.link_type || "",
                link_entity_slug: item.link_entity_slug || "",
                link_entity_id: item.link_entity_id || "",
                link_entity_type: item.link_entity_type || "",
                link_url: item.link_url || ""
              };
            }
          );

          // Load existing config
          this.bannerConfig = {
            style: this.value.content_json.config.style || "grid",
            columns: this.value.content_json.config.columns || 2,
            padding: this.value.content_json.config.padding || 0
          };
        }
        this.savedBannerData = [...this.bannerItems];
        this.savedBannerConfig = { ...this.bannerConfig };
      }

      // Update content type
      this.contentType = value;

      // Set appropriate contentDataFrom
      if (value === "banner") {
        this.contentDataFrom = "banner";

        // Restore saved banner data if exists
        if (this.savedBannerData) {
          this.bannerItems = [...this.savedBannerData];
          this.bannerConfig = { ...this.savedBannerConfig };
        }
      } else if (value === "item_list") {
        this.contentDataFrom = "video";
      }

      // Update content after state changes
      this.$nextTick(() => {
        this.updateContent();
      });
    },
    openContentDialog() {
      // Set contentDataFrom based on existing content type
      this.contentDataFrom =
        this.value.content_json.content.entity_type ||
        (this.contentType === "banner" ? "banner" : "video");

      // Initialize banner content if needed
      if (this.contentType === "banner") {
        // First check for saved data
        if (this.savedBannerData && this.savedBannerConfig) {
          this.bannerItems = [...this.savedBannerData];
          this.bannerConfig = { ...this.savedBannerConfig };
        }
        // If no saved data, check for existing content
        else if (
          this.value &&
          this.value.content_json &&
          this.value.content_json.content
        ) {
          // Load existing banner items
          this.bannerItems = this.value.content_json.content.images.map(
            item => {
              if (typeof item === "string") {
                return {
                  image: item,
                  link_type: "",
                  link_entity_slug: "",
                  link_entity_id: "",
                  link_entity_type: "",
                  link_url: ""
                };
              }
              return {
                image: item.image,
                link_type: item.link_type || "",
                link_entity_slug: item.link_entity_slug || "",
                link_entity_id: item.link_entity_id || "",
                link_entity_type: item.link_entity_type || "",
                link_url: item.link_url || ""
              };
            }
          );

          // Load existing config
          this.bannerConfig = {
            style: this.value.content_json.config.style || "grid",
            columns: this.value.content_json.config.columns || 2,
            padding: this.value.content_json.config.padding || 0
          };
        } else {
          // Initialize empty banner state for new content
          this.bannerItems = [];
          this.bannerConfig = {
            style: "grid",
            columns: 2,
            padding: 0
          };
        }
      } else {
        // Handle existing item list content
        if (
          this.value &&
          this.value.content_json &&
          this.value.content_json.content
        ) {
          if (this.contentDataFrom === "product") {
            this.item_list_product_ids_input = this.value.content_json.content.entity_ids
              .map(item =>
                this.item_list_product_ids_options.find(ep => ep.value == item)
              )
              .filter(item => !!item);
          } else if (this.contentDataFrom === "video") {
            this.item_list_video_ids_input = this.value.content_json.content.entity_ids
              .map(item =>
                this.item_list_video_ids_options.find(ep => {
                  return ep.value == item;
                })
              )
              .filter(item => !!item);
          } else if (this.contentDataFrom === "event") {
            this.item_list_event_ids_input = this.value.content_json.content.entity_ids
              .map(item =>
                this.item_list_event_ids_options.find(ep => {
                  return ep.value == item;
                })
              )
              .filter(item => !!item);
          }
        }
      }

      // Load publish dates
      this.publishStartDate = this.value.datetime_start || null;
      this.publishEndDate = this.value.datetime_end || null;

      // Open dialog
      this.editContentDialog = true;
    },
    onDragLeave(e) {
      e.preventDefault();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDragging = false;
      }
    },

    onDrop(e) {
      this.isDragging = false;
      this.dragCounter = 0;
      const files = e.dataTransfer.files;
      this.uploadFiles(files);
    },
    getVideoPreviewImage(videoSlug) {
      const video = this.item_list_video_ids_options.find(v => {
        return v.item && v.item.slug == videoSlug;
      });
      return video ? video.poster : "";
    },

    getVideoTitle(videoSlug) {
      const video = this.item_list_video_ids_options.find(
        v => v.item && v.item.slug === videoSlug
      );
      return video ? video.label : "";
    },
    getProductPreviewImage(slug) {
      const product = this.products.find(v => {
        return v.slug == slug;
      });
      return product ? product.poster : "";
    },

    getProductTitle(slug) {
      const product = this.products.find(v => {
        return v.slug == slug;
      });
      return product ? product.pro_title : "";
    },

    unlinkVideo(index) {
      this.bannerItems[index].videoSlug = null;
      this.bannerItems[index].linkType = "none";
    },

    formatUrl(url) {
      // Add https if no protocol specified
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }
      // Truncate long URLs
      return url.length > 40 ? url.substring(0, 37) + "..." : url;
    },

    handleLinkTypeChange(index, linkType) {
      // Reset all link-related fields
      this.bannerItems[index].link_type = linkType;
      this.bannerItems[index].link_entity_slug = "";
      this.bannerItems[index].link_entity_id = "";
      this.bannerItems[index].link_entity_type = "";
      this.bannerItems[index].link_url = "";
    },
    handleEntityTypeChange(index, entityType) {
      this.bannerItems[index].link_entity_type = entityType;
      this.bannerItems[index].link_entity_slug = "";
      this.bannerItems[index].link_entity_id = "";
    },
    linkEntityToBanner(index, selectedOption, entityType) {
      if (selectedOption) {
        this.bannerItems[index].link_entity_slug = selectedOption.value;
        this.bannerItems[index].link_entity_id = selectedOption.id;
        this.bannerItems[index].link_entity_type = entityType;
      } else {
        this.unlinkEntity(index);
      }
    },

    unlinkEntity(index) {
      this.bannerItems[index].link_entity_slug = "";
      this.bannerItems[index].link_entity_id = "";
      this.bannerItems[index].link_entity_type = "";
    },
    updateBannerItemUrl(index, url) {
      this.bannerItems[index].url = url;
    },
    handleBannerImageUpload(e) {
      const files = e.target.files;
      this.uploadFiles(files);
      e.target.value = ""; // Reset input
    },
    async uploadFiles(files) {
      // Filter for only image files
      const imageFiles = Array.from(files).filter(file =>
        file.type.startsWith("image/")
      );

      if (imageFiles.length === 0) {
        this.$vs.notify({
          title: "Error",
          text: "Please upload only image files",
          color: "danger"
        });
        return;
      }

      this.$vs.loading();

      for (let i = 0; i < imageFiles.length; i++) {
        const file = imageFiles[i];
        try {
          const formData = new FormData();
          formData.append("banner", file);
          formData.append("s", this.s);
          formData.append("e", this.e);

          const response = await Service.Content.uploadPageBanner(
            this.page_id,
            formData
          );

          // Push new banner item with updated structure
          this.bannerItems.push({
            image: response.data.path,
            link_type: "", // Default to no link
            link_entity_slug: "", // Empty string for no link
            link_entity_id: "", // Empty string for no link
            link_entity_type: "", // Empty string for no link
            link_url: "" // Empty string for no link
          });

          this.$vs.notify({
            title: "Success",
            text: `${file.name} uploaded successfully`,
            color: "success"
          });
        } catch (error) {
          this.$vs.notify({
            title: "Error",
            text: `Failed to upload ${file.name}`,
            color: "danger"
          });
          console.error("Error uploading image:", error);
        }
      }

      this.$vs.loading.close();
    },

    getVideoOption(videoSlug) {
      if (!videoSlug) return null;
      return this.videoSelectOptions.find(option => option.value === videoSlug);
    },
    getProductOption(slug) {
      if (!slug) return null;
      const foundItem = this.productSelectOptions.find(option => {
        return option.value == slug;
      });
      return foundItem;
    },

    linkVideoToBanner(index, selectedOption) {
      if (selectedOption) {
        this.bannerItems[index].videoSlug = selectedOption.value; // Save the slug
      } else {
        this.bannerItems[index].videoSlug = null;
      }
    },

    removeBannerItem(index) {
      this.bannerItems.splice(index, 1);
    },
    updateContent() {
      let contentJson = {};

      if (!this.isValidDateRange) {
        this.$vs.notify({
          title: "Invalid Date Range",
          text: "End date must be after start date",
          color: "danger"
        });
        return;
      }

      if (this.contentDataFrom === "banner") {
        contentJson = {
          content: {
            images: this.bannerItems
          },
          config: {
            style: this.bannerConfig.style,
            columns: this.bannerConfig.columns,
            padding: this.bannerConfig.padding
          }
        };
      } else {
        // Handle product and video content types as before
        contentJson = {
          content: {
            entity_ids:
              this.contentDataFrom == "event"
                ? this.item_list_event_ids_input.map(item => item.value)
                : this.contentDataFrom == "product"
                ? this.item_list_product_ids_input.map(item => item.value)
                : this.contentDataFrom == "video"
                ? this.item_list_video_ids_input.map(item => item.value)
                : this.item_list_speaker_ids_input.map(item => item.value),
            entity_type: this.contentDataFrom
          },
          config: {
            source: "selected_then_dynamic",
            style: "grid",
            columns: 3
          }
        };
      }

      this.$emit("input", {
        content_id: this.value.content_id,
        title: this.title,
        content_uuid: this.value.content_uuid,
        entity_id: this.value.entity_id,
        entity_type: this.value.entity_type,
        type: this.contentType,
        content_json: contentJson,
        datetime_start: this.publishStartDate,
        datetime_end: this.publishEndDate,
        publish_status: this.value.publish_status,
        listing_status: this.value.listing_status,
        trash_status: this.value.trash_status,
        trash_date: this.value.trash_date,
        show: true
      });
      this.editContentDialog = false;
    },
    onAddEventItemList() {
      if (!this.item_list_event_ids_search) {
        return;
      }
      this.item_list_event_ids_input.push({
        label: this.item_list_event_ids_search.label,
        value: this.item_list_event_ids_search.value,
        e: this.item_list_event_ids_search.e,
        poster: this.item_list_event_ids_search.poster
      });
      this.item_list_event_ids_search = "";
    },
    onAddProductItemList() {
      if (!this.item_list_product_ids_search) {
        return;
      }
      this.item_list_product_ids_input.push({
        label: this.item_list_product_ids_search.label,
        value: this.item_list_product_ids_search.value,
        e: this.item_list_product_ids_search.e,
        poster: this.item_list_product_ids_search.poster
      });
      this.item_list_product_ids_search = "";
    },
    removeItemListEvent(id) {
      this.item_list_event_ids_input = this.item_list_event_ids_input.filter(
        item => item.value != id
      );
    },
    removeItemListProduct(id) {
      this.item_list_product_ids_input = this.item_list_product_ids_input.filter(
        item => item.value != id
      );
    },
    onAddVideoItemList() {
      if (!this.item_list_video_ids_search) {
        return;
      }
      this.item_list_video_ids_input.push({
        label: this.item_list_video_ids_search.label,
        value: this.item_list_video_ids_search.value,
        item: this.item_list_video_ids_search.item,
        poster: this.item_list_video_ids_search.poster
      });
      this.item_list_video_ids_search = "";
    },
    removeItemListVideo(id) {
      this.item_list_video_ids_input = this.item_list_video_ids_input.filter(
        item => item.value != id
      );
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    uuid(n = 8) {
      var char = "";
      for (let i = 0; i < n; i += 1) {
        char += String.fromCharCode(this.getRandomInt(65, 90)); //alphanumeric chars
      }
      return char;
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$vs.notify({
          title: "Load failed",
          text: "Only support uploading one file!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: "Load failed",
          text: "Only supports upload .csv suffix files",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return false;
      }
      this.uploadFile(rawFile);
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFile(rawFile);
    },
    handleClickCheckboxes(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFileCheckboxes(rawFile);
    },
    isExcel(file) {
      return /\.(csv)$/.test(file.name);
    },
    uploadFile(file) {
      this.$refs["fileInput"].value = null; // fix can't select the same excel
      this.readerDataForRadio(file);
    },
    uploadFileCheckboxes(file) {
      this.$refs["fileInput"].value = null; // fix can't select the same excel
      this.readerDataForCheckbox(file);
    },
    handleContentTypeChange() {
      const qt = this.contentTypes[0].options.find(
        item => item.slug == this.contentType
      );
      if (
        qt &&
        this.contentTypes[0].options.find(item => this.content == item.label)
      ) {
        this.content = qt.label;
      }
      // else {
      //   this.content = "";
      // }
      this.updateContent();
    },
    addRadioOption(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.radioOptions.push({
          value: "",
          actions: {}
        });
      } else {
        this.radioOptions.splice(index + 1, 0, {
          value: "",
          actions: {}
        });
      }
      // Move the "Other" option to the last item
      const otherIndex = this.radioOptions.findIndex(option => option.is_other);

      let lastindex = this.radioOptions.length - 1;
      if (otherIndex !== -1) {
        const otherOption = this.radioOptions.splice(otherIndex, 1)[0];
        this.radioOptions.push(otherOption);
        lastindex = this.radioOptions.length - 2;
      }
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateContent();
      this.$nextTick(() => {
        this.$refs["radio-" + lastindex][0].focusInput();
      });
    },
    addOtherOption() {
      // Check if "Other" option already exists
      const otherIndex = this.radioOptions.findIndex(option => option.is_other);
      if (otherIndex === -1) {
        // Add "Other" option at the end of the array
        this.radioOptions.push({
          value: "Other",
          is_other: true,
          actions: {}
        });
      }
      this.updateContent();
    },
    isOtherOption(index) {
      // Check if the current option is "Other"
      return this.radioOptions[index] && this.radioOptions[index].is_other;
    },
    addCheckboxOtherOption() {
      // Check if "Other" option already exists
      const otherIndex = this.checkboxOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex === -1) {
        // Add "Other" option at the end of the array
        this.checkboxOptions.push({
          value: "Other",
          is_other: true,
          actions: {}
        });
      }
      this.updateContent();
    },
    isCheckboxOtherOption(index) {
      // Check if the current option is "Other"
      return (
        this.checkboxOptions[index] && this.checkboxOptions[index].is_other
      );
    },
    addDropdownOtherOption() {
      // Check if "Other" option already exists
      const otherIndex = this.selectOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex === -1) {
        // Add "Other" option at the end of the array
        this.selectOptions.push({
          value: "Other",
          is_other: true,
          actions: {}
        });
      }
      this.updateContent();
    },
    isDropdownOtherOption(index) {
      // Check if the current option is "Other"
      return this.selectOptions[index] && this.selectOptions[index].is_other;
    },
    removeRadioOption(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.radioOptions.length) {
        // Remove the radio option at the specified index
        this.radioOptions.splice(index, 1);
        this.updateContent();
      }
    },
    removeOtherOption() {
      // Remove the "Other" option
      const otherIndex = this.radioOptions.findIndex(option => option.is_other);
      if (otherIndex !== -1) {
        this.radioOptions.splice(otherIndex, 1);
        this.updateContent();
      }
    },
    removeCheckboxOtherOption() {
      // Remove the "Other" option
      const otherIndex = this.checkboxOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex !== -1) {
        this.checkboxOptions.splice(otherIndex, 1);
        this.updateContent();
      }
    },
    removeDropdownOtherOption() {
      // Remove the "Other" option
      const otherIndex = this.selectOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex !== -1) {
        this.selectOptions.splice(otherIndex, 1);
        this.updateContent();
      }
    },
    addCheckboxOption(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.checkboxOptions.push({
          value: "",
          actions: {}
        });
      } else {
        this.checkboxOptions.splice(index + 1, 0, {
          value: "",
          actions: {}
        });
      }
      // Move the "Other" option to the last item
      const otherIndex = this.checkboxOptions.findIndex(
        option => option.is_other
      );

      let lastindex = this.checkboxOptions.length - 1;
      if (otherIndex !== -1) {
        const otherOption = this.checkboxOptions.splice(otherIndex, 1)[0];
        this.checkboxOptions.push(otherOption);
        lastindex = this.checkboxOptions.length - 2;
      }
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateContent();
      this.$nextTick(() => {
        this.$refs["checkbox-" + lastindex][0].focusInput();
      });
    },
    removeCheckboxOption(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.checkboxOptions.length) {
        // Remove the checkbox option at the specified index
        this.checkboxOptions.splice(index, 1);
      }
    },
    addSelectOption(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.selectOptions.push({
          value: "",
          actions: {}
        });
      } else {
        this.selectOptions.splice(index + 1, 0, {
          value: "",
          actions: {}
        });
      }
      // Move the "Other" option to the last item
      const otherIndex = this.selectOptions.findIndex(
        option => option.is_other
      );

      let lastindex = this.selectOptions.length - 1;
      if (otherIndex !== -1) {
        const otherOption = this.selectOptions.splice(otherIndex, 1)[0];
        this.selectOptions.push(otherOption);
        lastindex = this.selectOptions.length - 2;
      }
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateContent();
      this.$nextTick(() => {
        this.$refs["select-" + lastindex][0].focusInput();
      });
    },
    removeSelectOption(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.selectOptions.length) {
        // Remove the select option at the specified index
        this.selectOptions.splice(index, 1);
      }
    },
    addRankRows(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.rankRows.push("");
      } else {
        this.rankRows.splice(index + 1, 0, "");
      }

      let lastindex = this.rankRows.length - 1;
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateContent();
      this.$nextTick(() => {
        this.$refs["rankrow-" + lastindex][0].focusInput();
      });
    },
    addRankCols(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.rankColumns.push("");
      } else {
        this.rankColumns.splice(index + 1, 0, "");
      }

      let lastindex = this.rankColumns.length - 1;
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateContent();
      this.$nextTick(() => {
        this.$refs["rankcol-" + lastindex][0].focusInput();
      });
    }
  }
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #f8f8f8;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
/* Add your custom styles here */

/* Apply custom styles to the container */
.drag-handle i,
.radio-drag-handle i {
  color: rgb(98, 98, 98);
}
.page-content-wrapper .drag-handle,
.page-content-wrapper .btn-panel {
  /* opacity: 0; */
  transition: width opacity ease 0.3s;
}
.page-content-wrapper:hover .drag-handle,
.page-content-wrapper:hover .btn-panel {
  opacity: 1;
}
.content-container {
}

/* Style the left side */
.left-side {
  flex: 1;
  margin-right: 20px;
}

/* Style the rows in the left side */
.left-side-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

/* Style the Radio Options container */
.radio-options-container,
.checkbox-options-container,
.select-options-container {
  display: block;
  /* flex-wrap: wrap; */
}

/* Style each Radio Options item */
.radio-option,
.select-option,
.checkbox-option {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

/* Style the dot */
.dot {
  margin-right: 5px;
}

/* Style the right side */
.right-side {
  flex: 1;
}

/* Add space on the left of the Add Option button */
.add-option-button {
  margin-left: 10px;
}

/* Style the remove button */
.remove-button {
  color: red;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

/* Style the container for Hide and Required */
.show-required-container {
  display: flex;
  align-items: center;
}
.drag-handle {
  cursor: grab;
  margin-right: 8px;
}
.radio-drag-handle i {
  cursor: grab;
  margin-right: 8px;
  opacity: 0;
  transition: opacity ease 0.1s;
}

.radio-drag-handle:hover i {
  opacity: 1;
}

.btn-panel {
  background: #f4f4f4;
  padding: 6px 6px;
  font-size: 1.5rem;
  border-radius: 2rem;
}
.btn-panel > div {
  padding: 4px 0;
}
.btn-panel i {
  font-size: 1.5rem;
  cursor: pointer;
  transition: all ease 0.1s;
}
.btn-panel i:hover {
  transform: scale(1.2);
}
.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 162px;
  z-index: 800;
}

.sticky-menu-2 {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 122px;
  z-index: 800;
}

.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 182px;
  z-index: 800;
}

.sticky-menu .sticking {
  background-color: #fff;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
}

.banner-preview {
  display: grid;
  width: 100%;
}

.banner-preview-item {
  border-radius: 8px;
  overflow: hidden;
}
.banner-item-card .vs-select {
  margin-bottom: 0.5rem;
}

.banner-item-card .vs-input {
  margin-bottom: 0.5rem;
}

.link-type-select {
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 0.9rem;
  height: auto;
  padding: 0.4rem;
}

.link-type-select:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25);
}

/* Optional: Style the dropdown arrow */
.link-type-select.custom-select {
  background-position: right 0.5rem center;
}

.upload-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  transition: all 0.3s ease;
  background: #f8f8f8;
  cursor: pointer;
}

.upload-area.dragging {
  border-color: #7367f0;
  background: #f0f0f0;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.upload-icon {
  font-size: 3rem;
  color: #666;
}

.upload-text {
  margin: 0;
  font-size: 1.1rem;
  color: #666;
}

.upload-button {
  color: #7367f0;
  text-decoration: underline;
  cursor: pointer;
}

.upload-button:hover {
  color: #4839eb;
}

.upload-hint {
  margin: 0;
  font-size: 0.9rem;
  color: #999;
}

.hidden {
  display: none;
}

.banner-items-container {
  margin-bottom: 2rem;
}

.banner-item-card {
  margin-bottom: 1rem;
}

.banner-item-image {
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  overflow: hidden;
}

.banner-item-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-section {
  background: #f8f8f8;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 2rem;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.preview-controls {
  display: flex;
  gap: 0.5rem;
}

.preview-container {
  background: white;
  padding: 1rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.preview-container.desktop {
  width: 100%;
}

.preview-container.tablet {
  width: 768px;
  margin: 0 auto;
}

.preview-container.mobile {
  width: 375px;
  margin: 0 auto;
}

.banner-preview {
  display: grid;
  width: 100%;
}

.grid-view {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.carousel-view {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  overflow-x: auto;
}

.banner-preview-item {
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  border-radius: 8px;
  overflow: hidden;
}

.banner-preview-item img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Active state for preview control buttons */
.preview-controls .vs-button.active {
  background-color: #7367f0;
  color: white;
}

.video-link-section {
  margin-top: 0.5rem;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0.5rem;
}

.video-preview {
  background: #f8f8f8;
  border-radius: 4px;
  overflow: hidden;
}

.video-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: #f1f1f1;
  border-bottom: 1px solid #eee;
}

.video-preview-label {
  font-size: 0.8rem;
  color: #666;
  font-weight: 500;
}

.video-preview-content {
  position: relative;
  overflow: hidden;
}

.video-thumbnail {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
}

.video-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  padding: 0.5rem;
  color: white;
}

.video-title {
  font-size: 0.8rem;
  margin-bottom: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  opacity: 0.8;
}

.video-preview-content:hover .play-icon {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1.1);
  transition: all 0.2s ease;
}

.url-hint {
  display: block;
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.8rem;
}

.text-danger {
  color: #ea5455;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.8;
}

/* Ensure consistent spacing */
.vs-input {
  margin-bottom: 0.25rem;
}

.banner-item-card {
  transition: all 0.3s ease;
}

.banner-item-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.fixed-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
  z-index: 1000;
}

.bottom-bar-content {
  padding: 1rem 8rem;
  display: flex;
  justify-content: flex-end;
  max-width: 100%;
  margin: 0 auto;
}

.apply-button {
  min-width: 100px;
}

.vs-popup::after {
  content: "";
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.9));
  pointer-events: none;
}
.image-container {
  position: relative;
  width: 100%;
  /* padding-top: 20%; */
  min-height: 350px;
  overflow: hidden;
}

.aspect-ratio-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-remove-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 10;
  cursor: pointer;
  background: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.banner-remove-btn i {
  /* color: #ea5455; */
  font-size: 24px;
}

.banner-remove-btn:hover {
  transform: scale(1.1);
}

.banner-remove-btn:active {
  transform: scale(0.95);
}
</style>

<style>
.hide-select-action .vs__actions {
  display: none;
}
.close-btn {
  font-size: 24px;
  position: absolute;
  right: -12px;
  top: -12px;
  cursor: pointer;
}
</style>
